import _ from 'lodash';

const addFontsComScript = _.once(() => {
  // @ts-ignore
  window.MTIProjectId = 'de237595-751b-4f73-be8c-ac926fb99db5';

  const mtiTracking = document.createElement('script');
  mtiTracking.type = 'text/javascript';
  mtiTracking.async = true;
  mtiTracking.src = '/mtiFontTrackingCode.js';
  (
    document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]
  ).appendChild(mtiTracking);
});

export default addFontsComScript;
